
import Vue from 'vue'

const locales = {keys(){return []}}
global['____FB5DF3F____'] = true;
delete global['____FB5DF3F____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"@/uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"preloadRule":{},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"","navigationBarBackgroundColor":"#fff","backgroundColor":"#F8F8F8","usingComponents":{"painter":"/wxcomponents/painter/painter"}},"tabBar":{"custom":true,"color":"#909399","selectedColor":"#303133","borderStyle":"black","backgroundColor":"#ffffff","list":[{"pagePath":"pages/index/index","iconPath":"static/images/icons/home/home.png","selectedIconPath":"static/images/icons/home/home-active.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/notice/list","iconPath":"static/images/icons/home/job.png","selectedIconPath":"static/images/icons/home/job-active.png","text":"公告","redDot":false,"badge":""},{"pagePath":"pages/recruit/list","iconPath":"static/images/icons/home/recruit.png","selectedIconPath":"static/images/icons/home/recruit-active.png","text":"职位","redDot":false,"badge":""},{"pagePath":"pages/my/my","iconPath":"static/images/icons/home/my.png","selectedIconPath":"static/images/icons/home/my-active.png","text":"我的","redDot":false,"badge":""}]},"lazyCodeLoading":"requiredComponents"};
global.__uniConfig.compilerVersion = '4.75';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__FB5DF3F';
global.__uniConfig.appName = '打听猫招聘';
global.__uniConfig.appVersion = '1.5.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/app/"};
global.__uniConfig.publicPath = "/app/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"amap":{"key":"d08cca18a325c692351c045f8fa2f4fd","securityJsCode":"c3853d3c17bd639461394b4ea8db4886","serviceHost":""}}};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = "d08cca18a325c692351c045f8fa2f4fd";
global.__uniConfig.aMapSecurityJsCode = "c3853d3c17bd639461394b4ea8db4886";
global.__uniConfig.aMapServiceHost = "";
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-substation', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/index/substation"+'.vue')), 'pages-index-substation'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-webview-webview', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/webview/webview"+'.vue')), 'pages-webview-webview'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-resetPassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/login/forgotPassword/resetPassword"+'.vue')), 'pages-login-forgotPassword-resetPassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-appealPassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/login/forgotPassword/appealPassword"+'.vue')), 'pages-login-forgotPassword-appealPassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword-codePassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/login/forgotPassword/codePassword"+'.vue')), 'pages-login-forgotPassword-codePassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/notice/list"+'.vue')), 'pages-notice-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/notice/detail"+'.vue')), 'pages-notice-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/recruit/list"+'.vue')), 'pages-recruit-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-recruit-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/recruit/detail"+'.vue')), 'pages-recruit-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-recoveryError', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/notice/recoveryError"+'.vue')), 'pages-notice-recoveryError'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/my/my"+'.vue')), 'pages-my-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-search', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/index/search"+'.vue')), 'pages-index-search'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-selectLogin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pages/login/selectLogin"+'.vue')), 'pages-login-selectLogin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-register-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/register/index"+'.vue')), 'pagesMy-register-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-mySet', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/mySet/mySet"+'.vue')), 'pagesMy-my-mySet-mySet'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changePhone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/mySet/setAccount/changePhone"+'.vue')), 'pagesMy-my-mySet-setAccount-changePhone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changePassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/mySet/setAccount/changePassword"+'.vue')), 'pagesMy-my-mySet-setAccount-changePassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-mySet-setAccount-changeNickname', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/mySet/setAccount/changeNickname"+'.vue')), 'pagesMy-my-mySet-setAccount-changeNickname'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myFeedback', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/myFeedback"+'.vue')), 'pagesMy-my-myFeedback'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myFollowArticle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/myFollowArticle"+'.vue')), 'pagesMy-my-myFollowArticle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-contactService', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/contactService"+'.vue')), 'pagesMy-my-contactService'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myCollect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/myCollect"+'.vue')), 'pagesMy-my-myCollect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-my-myResume', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/my/myResume"+'.vue')), 'pagesMy-my-myResume'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-information', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/information"+'.vue')), 'pagesMy-basic-information'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-eduction', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/eduction"+'.vue')), 'pagesMy-basic-eduction'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-applyRegion', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/applyRegion"+'.vue')), 'pagesMy-basic-applyRegion'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-selectSchool', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/selectSchool"+'.vue')), 'pagesMy-basic-selectSchool'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-certificates', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/certificates"+'.vue')), 'pagesMy-basic-certificates'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-work', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/work"+'.vue')), 'pagesMy-basic-work'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-changeEduction', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/changeEduction"+'.vue')), 'pagesMy-basic-changeEduction'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pagesMy-basic-addEduction', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/duanmin/www/dtmgk/dtmgk_client/pagesMy/basic/addEduction"+'.vue')), 'pagesMy-basic-addEduction'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"打听猫公考","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:44
}
},
{
path: '/pages/index/substation',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"分站"})
      },
      [
        createElement('pages-index-substation', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-substation',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/substation',
  windowTop:0
}
},
{
path: '/pages/webview/webview',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-webview-webview', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-webview-webview',
  isNVue:false,maxWidth:0,
  pagePath:'pages/webview/webview',
  windowTop:44
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/resetPassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-login-forgotPassword-resetPassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-resetPassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/resetPassword',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/appealPassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-login-forgotPassword-appealPassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-appealPassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/appealPassword',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword/codePassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-login-forgotPassword-codePassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword-codePassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword/codePassword',
  windowTop:44
}
},
{
path: '/pages/notice/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"招考公告"})
      },
      [
        createElement('pages-notice-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-notice-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/list',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/notice/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告详情"})
      },
      [
        createElement('pages-notice-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/detail',
  windowTop:44
}
},
{
path: '/pages/recruit/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"职位列表"})
      },
      [
        createElement('pages-recruit-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-recruit-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/list',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/recruit/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"职位详情"})
      },
      [
        createElement('pages-recruit-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-recruit-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/recruit/detail',
  windowTop:44
}
},
{
path: '/pages/notice/recoveryError',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"纠错"})
      },
      [
        createElement('pages-notice-recoveryError', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-recoveryError',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/recoveryError',
  windowTop:44
}
},
{
path: '/pages/my/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心","enablePullDownRefresh":false,"navigationBarBackgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-my-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-my-my',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/my',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:44
}
},
{
path: '/pages/index/search',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索","enablePullDownRefresh":false})
      },
      [
        createElement('pages-index-search', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-search',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/search',
  windowTop:44
}
},
{
path: '/pages/login/selectLogin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","enablePullDownRefresh":false})
      },
      [
        createElement('pages-login-selectLogin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-selectLogin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/selectLogin',
  windowTop:44
}
},
{
path: '/pagesMy/register/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账号注册","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-register-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-register-index',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/register/index',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/mySet',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账户设置","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-mySet', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-mySet',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/mySet',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changePhone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改手机号","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changePhone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changePhone',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changePhone',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changePassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changePassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changePassword',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changePassword',
  windowTop:44
}
},
{
path: '/pagesMy/my/mySet/setAccount/changeNickname',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改昵称","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-mySet-setAccount-changeNickname', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-mySet-setAccount-changeNickname',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/mySet/setAccount/changeNickname',
  windowTop:44
}
},
{
path: '/pagesMy/my/myFeedback',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"意见反馈","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-myFeedback', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myFeedback',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myFeedback',
  windowTop:44
}
},
{
path: '/pagesMy/my/myFollowArticle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关注公告","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-myFollowArticle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myFollowArticle',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myFollowArticle',
  windowTop:44
}
},
{
path: '/pagesMy/my/contactService',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"联系客服","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-contactService', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-contactService',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/contactService',
  windowTop:44
}
},
{
path: '/pagesMy/my/myCollect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收藏职位","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-my-myCollect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myCollect',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myCollect',
  windowTop:44
}
},
{
path: '/pagesMy/my/myResume',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"简历编辑"})
      },
      [
        createElement('pagesMy-my-myResume', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-my-myResume',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/my/myResume',
  windowTop:44
}
},
{
path: '/pagesMy/basic/information',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"基本信息","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-information', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-information',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/information',
  windowTop:44
}
},
{
path: '/pagesMy/basic/eduction',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"教育经历","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-eduction', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-eduction',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/eduction',
  windowTop:44
}
},
{
path: '/pagesMy/basic/applyRegion',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报考地区","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-applyRegion', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-applyRegion',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/applyRegion',
  windowTop:44
}
},
{
path: '/pagesMy/basic/selectSchool',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"毕业院校","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-selectSchool', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-selectSchool',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/selectSchool',
  windowTop:44
}
},
{
path: '/pagesMy/basic/certificates',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资格证书","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-certificates', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-certificates',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/certificates',
  windowTop:44
}
},
{
path: '/pagesMy/basic/work',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工作经验","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-work', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-work',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/work',
  windowTop:44
}
},
{
path: '/pagesMy/basic/changeEduction',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"教育经历","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-changeEduction', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-changeEduction',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/changeEduction',
  windowTop:44
}
},
{
path: '/pagesMy/basic/addEduction',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加教育经历","enablePullDownRefresh":false})
      },
      [
        createElement('pagesMy-basic-addEduction', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pagesMy-basic-addEduction',
  isNVue:false,maxWidth:0,
  pagePath:'pagesMy/basic/addEduction',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
